import { render, staticRenderFns } from "./Resultados.vue?vue&type=template&id=050a2e9c&scoped=true"
import script from "./Resultados.vue?vue&type=script&lang=js"
export * from "./Resultados.vue?vue&type=script&lang=js"
import style0 from "./Resultados.vue?vue&type=style&index=0&id=050a2e9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050a2e9c",
  null
  
)

export default component.exports